import React, { useEffect, useState } from "react";
import useTemplates from "../../services/Whatsapp/useTemplates";
import { Filter, Plus, RefreshCcw, Search } from "lucide-react";
import NoIndex from "../../components/NoIndex";
import LoadingScreen from "../../utils/LoadingScreen";
import { ToastContainer } from "react-toastify";

const TemplateCard = ({ template }) => {
  const isActive = template.status === "ACTIVE";

  return (
    <>
    <ToastContainer/>
   
    <div className="bg-white border rounded-lg flex flex-col justify-between h-full overflow-hidden montserrat-font-1">
      <div className="p-4 montserrat-font-1">
        <h3 className="text-md font-semibold">{template.event_type}</h3>

        <div className="h-px bg-gray-200 my-3"></div>

        <p className="text-sm text-gray-500 montserrat-font-2">{template.message}</p>
      </div>

      <div className="p-3 montserrat-font-1">
        <button
          className={`w-full text-sm font-semibold rounded-md px-3 py-2 transition
          ${
            isActive
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-500 border border-gray-300"
          }`}
        >
          Set as Default
        </button>
      </div>
    </div>
    </>
  );
};

const ChatBot = () => {
  const { fetchLibraryTemplates } = useTemplates();

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [search, setSearch] = useState("");

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const data = await fetchLibraryTemplates();
      setTemplates(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const filteredTemplates = templates.filter((t) =>
    t?.message?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <NoIndex />
      <ToastContainer/>
      <div className="p-4 px-6 h-full flex flex-col overflow-hidden montserrat-font-1">
  {/* HEADER */}
<div className="sticky top-0 z-30 pb-5">
  <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold">Chatbot Customization</h2>

          <div className="flex items-center gap-3 montserrat-font-1">
            {/* FILTER BUTTON */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="border rounded-md p-3 bg-white"
            >
              <Filter
                className="w-4 h-4 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
                strokeWidth={2.5}
              />
            </button>

            {/* SEARCH */}
            <div className="flex items-center border rounded-md px-2 bg-white montserrat-font-1">
              <Search
                className="w-4 h-4 mr-2 text-gray-500"
                strokeWidth={2.5}
              />
              <input
                type="text"
                placeholder="Search"
                className="outline-none text-sm py-2.5"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* CUSTOM MESSAGE */}
            <button className="flex items-center gap-2 border montserrat-font-1  border-blue-500 text-blue-600 px-3 py-2 bg-white rounded-md hover:bg-blue-50">
              <Plus className="w-4 h-4" />
              Custom Message
            </button>

            <button
              onClick={loadTemplates}
              className="flex items-center gap-2 border rounded-md px-4 py-2 text-white bg-green-500"
            >
              <RefreshCcw
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
              Refresh
            </button>
          </div>
        </div>
        </div>

        {/* CONTAINER */}
        {loading ? (
          <div className="flex items-center justify-center h-[60vh]">
            <div className="text-center">
              <LoadingScreen text="Updating ..." />
            </div>
          </div>
        ) : (
          <div className="overflow-x-auto scrollbar-hide pb-2montserrat-font-1">
            <div className="border bg-gray-50 rounded-xl p-6 overflow-hidden montserrat-font-1">
              {/* FILTER AREA */}
              {showFilters && (
                <div className="mb-5">
                  <p className="text-sm text-gray-500">Filters coming here</p>
                </div>
              )}

              {/* GRID */}
              <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-5 montserrat-font-1">
                {filteredTemplates.map((template, index) => (
                  <TemplateCard key={index} template={template} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ChatBot;
